import { initContract } from '@ts-rest/core';

import { authCheckoutComContract } from './checkoutCom.auth.contract';
import { publicCheckoutComContract } from './checkoutCom.public.contract';

const c = initContract();

export const checkoutComContract = c.router(
  {
    auth: authCheckoutComContract,
    public: publicCheckoutComContract,
  },
  {
    pathPrefix: '/checkout-com',
    strictStatusCodes: true,
  },
);

export * from './checkoutCom.auth.contract';
export * from './checkoutCom.public.contract';
